export default __webpack_public_path__ + "static/media/profile.241afea3.jpg";